import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj20 = () => {
  return (
    <Layout>
      <SEO
        title="Substituion Cipher-The Science of Secrecy"
        description="Awesome python project"
      />
      <Particle8></Particle8>
      <h6>s</h6>
      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-20">
          <div className="py-1-heading">
            <h1>Substituion Cipher-The Science of Secrecy</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/Substitution%20Cipher-The%20Science%20of%20Secrecy"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              Now, such project is responsible for increasing the interest in
              the field.
              <br />
              <br />
              String is used to represent text in python.
              <br />
              Text may comprises of spaces, numbers and alphabets.
              <br />
              <br />
              Caesar Cipher is the simplest form of making secrets.
              <br />
              <br />
              In this let a text have few words of english.
              <br />
              Now, shift all letters by 5 alphabets.
              <br />
              And here we go, <br />
              <br />
              The sceret is written...
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>String</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj20
